import React from "react";
import "./Loading.css";

const Loading = ({
  type = "spinner",     // "spinner" | "skeleton"
  rows = 5,             // Only used for skeleton version
  height = 50,          // Skeleton row height
}) => {
  if (type === "skeleton") {
    return (
      <div className="skeleton-wrapper">
        {Array.from({ length: rows }).map((_, i) => (
          <div
            key={i}
            className="skeleton-row"
            style={{ height }}
          ></div>
        ))}
      </div>
    );
  }

  // Default: Spinner
  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p className="loading-text">Loading...</p>
    </div>
  );
};

export default Loading;
